/**
 * GENERATED FILE — do not edit by hand.
 *
 * Names for the People-page Manager demo preset's fictional roster, produced
 * by `usersPage.demo.names.source.ts` and committed here so the shipped app
 * never imports faker's 25 locale-specific name-data packages (TT-5152 review).
 *
 * Regenerate with:
 *
 *     yarn generate-demo-names
 */

export const DEMO_NAMES: readonly string[] = [
  'Iseult Olivier',
  'Conchita Riojas Cordero',
  'Aleksy Mackiewicz',
  'Benito Cervantes Maya',
  'Lucia Olivo Chavarría',
  'Viễn Phương Trịnh',
  'Dobromír Šulcová',
  'Hannu Heinonen',
  'Dorka Molnár',
  'Artemisa Mariotti',
  'Thanh Nhã Hồ',
  'Susanna Ojala',
  'Tiina Hämäläinen',
  'Sofía Briones Hidalgo',
  'Toluwani Gbadamosi',
  'Elakshi Nambeesan',
  'Emerich Hudec',
  'Justin Miller-Tromp',
  'Eveliina Rantanen',
  'Nina Berglund',
  'Mandakini Trivedi',
  'Natalie Solberg',
  'Naim Gül',
  'Valentina Martens',
  'Billie Schultz',
  'Otilia Gerhold',
  'Alexa Ruiz Terán',
  'Évariste Simon',
  'Luiza Macedo',
  'Dorit Dam',
];
